        <ng-container *ngIf="!destAddIcon && destlogoUrl !== null && destlogoUrl !== undefined">
            <div (click)="$event.stopPropagation(); params.data.status !== 'DELETED' && routeToDetails()" class="source-destination-image" [ngClass]="[(['ENABLED', 'UPDATED', 'DELETED', 'PAUSED'].includes(params.data.status)?'cursor-pointer':''), (['PAUSED', 'DELETED'].includes(params.data.status)) ? 'faded' : '']">
                    <img [matTooltip]="params.data.destinationName" class="image-1-src tooltip hover-tooltip tooltip-sm pt-0" *ngIf="destlogoUrl !== null && destlogoUrl !== undefined"  src="../../assets/images/datawarehouselogos/{{destlogoUrl}}.png"  />

            </div>
        </ng-container>


     <div class="ml-3 d-flex align-items-center row  h-100" *ngIf="params.data.displayStatus === 'SAVED'" >
        <span class="text-strong-2">-/-</span>
    </div>

                        <div class="d-flex align-items-center row  h-100" *ngIf="params.data.displayStatus !== 'SAVED' && destAddIcon"  >

                            <div class="ml-3">
                                <div>
                                    <span (click)="$event.stopPropagation();" class="destination-action-plus" [matMenuTriggerFor]="destinationActionMenu" *ngIf="destlogoUrl !== undefined"  [matTooltip]="'Cannot set destination for this source'">+</span>
                                    <span class="destination-action-plus" [matMenuTriggerFor]="destinationActionMenu" (click)="$event.stopPropagation(); status=!status" *ngIf="destlogoUrl === null" [ngClass]="status ? 'show' : ''">+</span>

                                  </div>
                                  <mat-menu class="details-action-menu destination-attach-menu" #destinationActionMenu="matMenu">
                                        <div class="Integrations-dropdown-list my-scrollbar {{dataLength > 4 && ( (params.rowIndex + 4  === dataLength) || (params.rowIndex + 3  === dataLength) || (params.rowIndex + 2  === dataLength) || (params.rowIndex + 1  === dataLength) )?'integrations-dropdown-list-li':''}}" >
                                            <h6 class="mb-1">Choose Destination</h6>
                                            <p>Select the destination that you want to map for your source</p>
                                            <div class="Integrations-overflow">
                                                <ul class="Integrations-ul">
                                                    <ng-container *ngFor="let warehouse of warehouses; let i = index" >

                                                        <li *ngIf="warehouse.status === 'ENABLED'"  class="click-f {{(i === focusIndex?'focus-class':'')}}" (click)="$event.stopPropagation(); focusIndex = i">
                                                                <div class="Integrations-img">
                                                                    <img src="../../assets/images/datawarehouselogos/{{warehouse.logoUrl}}.png" alt="">
                                                                </div>
                                                                <div class="Integrations-details">
                                                                    <span class="text-strong-2">{{warehouse.name}}</span>
                                                                    <p>Receiving from {{warehouse.count}} sources</p>
                                                                </div>
                                                        </li>

                                                    </ng-container>
                                                </ul>
                                            </div>
                                            <div (click)="$event.stopPropagation(); routeToDest()" class="Integrations-addnew mt-3">
                                                <span><i class="fas fa-plus"></i> Add new Destination</span>
                                            </div>
                                            <div class="row justify-content-end mt-4">
                                                <div class="col-auto"><button mat-button color="primary" (click)="$event.stopPropagation(); closeDestinationActionMenu(); status=!status; focusIndex = undefined;">Cancel</button></div>
                                                <div class="col-auto pl-0"><button mat-flat-button color="primary" [disabled]="focusIndex === undefined" (click)="setWarehouse()">Confirm</button></div>
                                            </div>

                                        </div>
                                  </mat-menu>
                                  
                            </div>
                        </div>





